import useTexts from '../hooks/useTexts';
import type Lang from '../languages/lang';

interface Props {
  textKey: keyof Lang;
  textKeys?: (keyof Lang)[];
  separator?: string;
}

const DynamicSnackbarMessage = ({ textKey, textKeys, separator = '' }: Props) => {
  const texts = useTexts();
  if (textKeys) {
    return <>{textKeys.map((k) => texts[k]).join(separator)}</>;
  }
  return <>{texts[textKey]}</>;
};

export default DynamicSnackbarMessage;
